/* eslint-disable react-hooks/exhaustive-deps */
import CreateIcon from "@mui/icons-material/Create";
import ClearIcon from "@mui/icons-material/Clear";
import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_REPORT_OBSERVATION,
  SET_REPORT_OBSERVATION_COMMENTS,
  SET_REPORT_OBSERVATION_PHOTO,
  SET_REPORT_OBSERVATION_ROOM_NAME,
  SET_REPORT_OBSERVATION_TESTS,
  SHOW_MODAL,
  SET_REPORT_OBSERVATION_PROTOCOL_SUBTITLE,
  SET_REPORT_OBSERVATION_SAMPLE_INFO,
  SET_REPORT_OBSERVATION_PROTOCOL_TITLE,
  REMOVE_REPORT_OBSERVATION_COMMENTS,
} from "../../../../../store/actions";
import { isEmptyHtml } from "../../../../shared/helpers";

export function ObservationsEditable(props) {
  const {
    children,
    textArea,
    ml,
    innerHtml,
    reduxKey,
    oi,
    ci,
    pi,
    ri,
    ti,
    si,
    editRoomName,
    editProtocolSubTitle,
    editProtocolTitle,
    removeComment,
  } = props;
  const dispatch = useDispatch();

  const protocolTitleValue = useSelector((state) => {
    if (!editProtocolTitle || ri === undefined) {
      return undefined;
    }
    return state.report?.observations?.data?.[ri]
      ?.protocol_header_observation_consideration;
  });

  const protocolSubTitleValue = useSelector((state) => {
    if (!editProtocolSubTitle || ri === undefined) {
      return undefined;
    }
    return state.report?.observations?.data?.[ri]?.protocol_header_text;
  });

  const resolvedValue = useMemo(() => {
    if (editProtocolTitle && protocolTitleValue !== undefined) {
      return protocolTitleValue ?? "";
    }
    if (editProtocolSubTitle && protocolSubTitleValue !== undefined) {
      return protocolSubTitleValue ?? "";
    }
    return children ?? "";
  }, [
    children,
    editProtocolTitle,
    editProtocolSubTitle,
    protocolTitleValue,
    protocolSubTitleValue,
  ]);

  const ucp = useCallback(
    (path, text) => {
      const valueToPersist = text ?? "";

      if (ci !== undefined) {
        dispatch({
          type: SET_REPORT_OBSERVATION_COMMENTS,
          payload: {
            path,
            data: valueToPersist,
            observationIndex: oi,
            commentIndex: ci,
            roomIndex: ri,
          },
        });
      } else if (pi !== undefined) {
        dispatch({
          type: SET_REPORT_OBSERVATION_PHOTO,
          payload: {
            path,
            data: valueToPersist,
            observationIndex: oi,
            photoIndex: pi,
            roomIndex: ri,
          },
        });
      } else if (si !== undefined) {
        dispatch({
          type: SET_REPORT_OBSERVATION_SAMPLE_INFO,
          payload: {
            path,
            data: valueToPersist,
            observationIndex: oi,
            testIndex: ti,
            roomIndex: ri,
            sampleIndex: si,
          },
        });
      } else if (ti !== undefined) {
        dispatch({
          type: SET_REPORT_OBSERVATION_TESTS,
          payload: {
            path,
            data: valueToPersist,
            observationIndex: oi,
            testIndex: ti,
            roomIndex: ri,
          },
        });
      } else if (editRoomName) {
        dispatch({
          type: SET_REPORT_OBSERVATION_ROOM_NAME,
          payload: { path, data: valueToPersist, roomIndex: ri },
        });
      } else if (editProtocolSubTitle) {
        dispatch({
          type: SET_REPORT_OBSERVATION_PROTOCOL_SUBTITLE,
          payload: { path, data: valueToPersist, roomIndex: ri },
        });
      } else if (editProtocolTitle) {
        dispatch({
          type: SET_REPORT_OBSERVATION_PROTOCOL_TITLE,
          payload: { path, data: valueToPersist, roomIndex: ri },
        });
      } else {
        dispatch({
          type: SET_REPORT_OBSERVATION,
          payload: {
            path,
            data: valueToPersist,
            observationIndex: oi,
            roomIndex: ri,
          },
        });
      }
    },
    [
      dispatch,
      ci,
      pi,
      si,
      ti,
      oi,
      ri,
      editRoomName,
      editProtocolSubTitle,
      editProtocolTitle,
    ]
  );

  const openModal = useCallback(() => {
    const initialValue = resolvedValue ?? "";

    dispatch({
      type: SHOW_MODAL,
      payload: {
        show: true,
        value: initialValue,
        setValue: (t) => ucp(reduxKey, t),
        textArea: textArea,
        ml: ml,
        richText: innerHtml,
        roomIndex: ri,
        customEditorType: undefined,
      },
    });
  }, [dispatch, resolvedValue, reduxKey, textArea, ml, innerHtml, ri, ucp]);

  const deleteComment = useCallback(
    (path) => {
      dispatch({
        type: REMOVE_REPORT_OBSERVATION_COMMENTS,
        payload: {
          path,
          roomIndex: ri,
          observationIndex: oi,
          commentIndex: ci,
        },
      });
    },
    [dispatch, ri, oi, ci]
  );

  return (
    <div className="editable-text">
      <div className="tools pen">
        <CreateIcon color="#2f481e" onClick={openModal} />
      </div>

      {innerHtml ? (
        <span
          dangerouslySetInnerHTML={{
            __html: !isEmptyHtml(children) ? children : "Click to add text",
          }}
          className="no-margin"
          onClick={openModal}
        ></span>
      ) : (
        <span onClick={openModal} className="break-text">
          {children || "Click to add text"}
        </span>
      )}

      <div className="tools cross">
        <ClearIcon
          color="#b44a4a"
          onClick={() => {
            if (removeComment) {
              deleteComment(reduxKey);
            } else {
              ucp(reduxKey, "");
            }
          }}
        />
      </div>
    </div>
  );
}
